import ObjectActionsType from "../types/ObjectActionsType";
export default class ObjectStateActionUtils {
    static dispatchObjectLoadStarted(reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.LOAD_STARTED)
        });
    }
    static dispatchObjectLoadSuccess(object, reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.LOAD_SUCCESS),
            object: object
        });
    }
    static dispatchObjectLoadFailed(error, reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.LOAD_FAILED),
            error: error
        });
    }
    static dispatchObjectReLoadStarted(reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.RELOAD_STARTED),
        });
    }
    static dispatchObjectReLoadSuccess(newObject, reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.RELOAD_SUCCESS),
            object: newObject
        });
    }
    static dispatchObjectReLoadFailed(error, reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.RELOAD_FAILED),
            error: error,
        });
    }
    static dispatchObjectSaveStarted(object, reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.SAVE_STARTED),
            object: object
        });
    }
    static dispatchObjectSaveSuccess(object, reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.SAVE_SUCCESS),
            object: object
        });
    }
    static dispatchObjectSaveFailed(error, reduxStateKey, dispatch) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(reduxStateKey, ObjectActionsType.SAVE_FAILED),
            error: error
        });
    }
    static dispatchUpdateArrayElement(element, arrayReduxStateKey, dispatch, predicate) {
        dispatch({
            type: ObjectStateActionUtils.createActionName(arrayReduxStateKey, ObjectActionsType.ELEMENT_UPDATED),
            predicate: predicate,
            element: element
        });
    }
    static createActionName(reduxStateKey, actionType) {
        return `@ACTION/${reduxStateKey}/${actionType}`;
    }
}
//# sourceMappingURL=ObjectStateActionUtils.js.map